import React, { Component } from 'react';
import { contactData } from '../Contacts/contact-data';

import './Orchestra.css';
import Directors from '../Tools/Directors';
import Info from '../Tools/Info';
import FullDirectory from '../Directory/FullDirectory/FullDirectory';
import Carousel from '../Tools/Carousel';

//files
import { FILE } from '../../utils/constants/pdf';

export default class Orchestra extends Component {
  state = {
    info: false,
    directory: false,
    department: 'Orchestra',
    directors: [],
    contest: [
      // { title: '2021/2022 Full Contest', href: FILE.contestSchedule2122 },
    ],
    files: [
      {
        title: 'Orchestra Concert Evaluation Rubric',
        href: FILE.orchConcertEval,
      },
      {
        title: 'Orchestra Sight Reading Evaluation Rubric',
        href: FILE.orchSightReading,
      },
      {
        title: 'Orchestra Form 4',
        href: FILE.orchForm4,
      },
      {
        title: 'Orchestra Form 5',
        href: FILE.orchForm5,
      },

      {
        title: 'UIL SightReading Instrution Pilot',
        href: FILE.sightreadingPilot,
      },
      {
        title: 'TMEA Contest Registration',
        href: 'https://www.tmea.org/divisions-regions/orchestra',
      },
      {
        title: 'UIL Contest Rules',
        href: 'https://www.uiltexas.org/policy/constitution/music',
      },
      {
        title: 'UIL Registration - Concert & Sight-Reading, Solo & Ensemble',
        href: 'https://www.texasmusicforms.com/',
      },
      {
        title: 'String/Mariachi/Guitar Solo & Ensemble Host Guidelines',
        href: FILE.conGuidelines,
      },
      {
        title: 'Orchetra Concert & Sightreaing Contest',
        href: FILE.soloGuidelines,
      },
      {
        title: 'Solo & Ensemble Entering Instructions',
        href: FILE.allSoloEntrance,
      },
      {
        title: 'Concert & SightReading Entering Instructions',
        href: FILE.allContestEntrance,
      },
      {
        title: 'State Instrumental Chamber Music Contest',
        href: FILE.chamberMusic,
      },
    ],
    imageList: [
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547224789/All_Region_Symphonic_Orchestra.jpg',
        school: 'Grand Prairie High School',
      },
    ],
  };

  componentDidMount() {
    this.getContacts();
  }

  getContacts() {
    const orchestra = 'Orchestra';
    // axios.get(`/api/contacts?department=${orchestra}`).then((res) => {
    //   this.setState({ directors: res.data });
    // });
    const contactsFilter = contactData[0].filter(el => el.department === 'ORCHESTRA')
    this.setState({ directors: contactsFilter });
  }

  toggleClick = (a, b) => {
    this.setState({
      info: a,
      directory: b,
    });
  };

  render() {
    const { info, directory, directors, files, contest } = this.state;

    return (
      <div className="band_main">
        <div className="component_img" />
        <div className="band_content">
          <div className="band_header">
            <div className="band_header_container">
              <div className="band_sub_nav">
                <h1
                  className="band_link a"
                  onClick={() => this.toggleClick(false, false)}
                >
                  Orchestra
                </h1>
                <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(true, false)}
                >
                  Information
                </h2>
                {/* <h2
                  className="band_link a bl-1"
                  onClick={() => this.toggleClick(false, true)}
                >
                  Directory
                </h2> */}
              </div>
            </div>
          </div>

          <div className="band_header_small">
            <div className="band_header_container">
              <div className="band_sub_nav small_sub">
                <h1
                  className="band_link a big-link"
                  onClick={() => this.toggleClick(false, false)}
                >
                  Orchestra
                </h1>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(true, false)}
                >
                  Information
                </h2>
                <h2
                  className="band_link a side-link"
                  onClick={() => this.toggleClick(false, true)}
                >
                  Directory
                </h2>
              </div>
            </div>
          </div>

          {!info && !directory && (
            <div className="band_home scroll">
              <h2>Our Directors</h2>
              <div className="map_holder">
                <Directors directors={directors} />
              </div>
            </div>
          )}
          {info && (
            <div className="band_high scroll">
              <Carousel imageList={this.state.imageList} />
              <Info
                contest={contest}
                files={files}
                title="Contest Rules and Links"
              />
            </div>
          )}
          {directory && (
            <div className="band_middle scroll">
              <h2 className="band_title">Directory</h2>
              <FullDirectory department={this.state.department} />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Orchestra/Orchestra.js